module.exports = __webpack_public_path__ + "static/media/service--mobile.1d985f0f.png";